import { useCallback, useState } from 'react'

export default function useBoolean(initial = false) {
  const [value, setValue] = useState<boolean>(initial)
  const setFalse = useCallback(() => setValue(false), [setValue])
  const setTrue = useCallback(() => setValue(true), [setValue])
  const toggle = useCallback(
    (newValue?: boolean) => {
      if (typeof newValue === 'boolean') {
        setValue(newValue)
      } else {
        setValue((value) => !value)
      }
    },
    [setValue]
  )

  return {
    value,
    setFalse,
    setTrue,
    toggle,
  }
}
